import React from 'react';
import TimeLineList from "../General/list/timelineList";
import {isAragUser} from "../../helpers/functions";
import CustomModal from "../General/customModal";
import FormGroupTextArea from "../formGroupTextArea";
import Button from "../button";
import CenteredDots from "../General/centeredDots";
import FormResponseMessage from "../formResponseMessage";

const PendingChangesTab = (props) => {
    const {
        userRoles,
        pendingChanges,
        onAccept,
        patchingId,
        errorMessage,
        errorItemId,
        rejectReason,
        isRejectModalOpen,
        onReject,
        closeRejectModal,
        onRejectReasonChange,
        onConfirmReject,
        pendingChangeItems,
        fetchingPendingChanges,
        fetchingEditingSettings,
        fetchingSelectedApp
    } = props;

    if(fetchingPendingChanges || fetchingEditingSettings || fetchingSelectedApp){
        return (
            <div className={"col-sm-12"}>
                <CenteredDots/>
            </div>
        )
    }

    return (
        <div className={'generalTab-wrapper'}>
            <CustomModal
                isOpen={isRejectModalOpen}
                content={(
                    <form className={"form-horizontal"}>
                        <FormGroupTextArea
                            centerWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                            Label={"Rejection Reason"}
                            Required={false}
                            Name={"rejectReason"}
                            Value={rejectReason}
                            HandleInputChange={onRejectReasonChange}
                        />
                        <div className={"form-group"}>
                            <div className={"col-sm-6 col-sm-offset-3"}>
                                <Button
                                    clickHandler={onConfirmReject}
                                    wrapper="btn-wrapper"
                                    btnType="button"
                                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                    label="Reject"
                                />
                                <Button
                                    clickHandler={closeRejectModal}
                                    wrapper="btn-wrapper"
                                    btnType="button"
                                    btnStyle={'btn btn-primary btn-xs sharp white'}
                                    label="Cancel"
                                />
                            </div>
                        </div>
                        {(
                            errorItemId
                        ) && (
                            <FormResponseMessage
                                Message={props.errorMessage}
                                CenterWrapper="col-sm-12 "
                                MessageStyle="formResponseMessage-reject"
                            />
                        )}
                        {(
                            patchingId
                        ) && (
                            <div className={'col-sm-12'}>
                                <CenteredDots/>
                            </div>
                        )}
                    </form>
                )}
                handleClose={closeRejectModal}
            />
            <TimeLineList
                listItems={pendingChangeItems}
                shouldDisplayActions={isAragUser(userRoles)}
                onAccept={onAccept}
                onReject={onReject}
                patchingItemId={patchingId}
                errorMessage={errorMessage}
                errorItemId={errorItemId}
            />
        </div>
    )
};

export default PendingChangesTab;